import React from 'react';

const MessageModal = ({
  msgSuperior,
  msgInferior,
  href,
  textoDoLink,
  onClick,
  abrirNovaJanela = true
}) => {
  
  return (
      <div className="custom-toast">
        <img
          alt="imagem de perfil da carol, assistente virtual dos correios"
          id="img-carol-boasvindas"
          src="/images/carol-perfil.png"
        />
        <p style={{ textAlign: 'justify' }}>
          {msgSuperior}
          <br />
          <a
            className="txt-link"
            href={href}                        
            target={abrirNovaJanela ? '_blank' : '_self'}
            rel="noopener noreferrer"
          >
            {textoDoLink}
          </a>
          <br />{msgInferior}
        </p>
        <button onClick={onClick}>OK</button>
      </div>
  );
};
export default MessageModal;
